var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7339 20C16.2567 20 20.7339 15.5228 20.7339 10C20.7339 4.47715 16.2567 0 10.7339 0C5.21104 0 0.733887 4.47715 0.733887 10C0.733887 15.5228 5.21104 20 10.7339 20ZM8.64895 12.0849H7.25899C7.25899 13.329 8.28061 14.3853 9.69142 14.7398V16.2548H11.7764V14.7398C13.1872 14.3853 14.2088 13.329 14.2088 12.0849C14.2088 10.1529 12.374 9.69421 10.9007 9.32587C9.37173 8.95753 8.64895 8.67954 8.64895 7.91506C8.64895 7.16448 9.60107 6.5251 10.7339 6.5251C11.8667 6.5251 12.8188 7.16448 12.8188 7.91506H14.2088C14.2088 6.67105 13.1872 5.61468 11.7764 5.26024V3.74519H9.69142V5.26024C8.28061 5.61468 7.25899 6.67105 7.25899 7.91506C7.25899 9.8471 9.09374 10.3058 10.5671 10.6741C12.096 11.0425 12.8188 11.3205 12.8188 12.0849C12.8188 12.8355 11.8667 13.4749 10.7339 13.4749C9.60107 13.4749 8.64895 12.8355 8.64895 12.0849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIcon);
export default __webpack_public_path__ + "static/media/loanIcon.264339a712a2c0489c5f4f1b55a729e1.svg";
export { ForwardRef as ReactComponent };